<template>
  <div>
    <button class="btn-small solidgreen modal-trigger" :href="'#modal'+uid">{{$t('menu.buttons.edit')}}</button>
    <button class="btn-small red" style="margin-top: 10px;" v-on:click="removeRecommendation(recommendation)">{{$t('menu.buttons.delete')}}</button>
    <div :id="'modal'+uid" class="modal">
      <div class="modal-content">
        <h5>{{$t('inspection.recommendation')}}</h5>
        <textarea v-model="recommendation.cause" :placeholder="$t('inspection.cause_placeholder')"/>
        <textarea v-model="recommendation.about" :placeholder="$t('inspection.about_placeholder')"/>
        <div class="row">
          <div class="col s6" style="line-height: 2.5; text-align: right;">
            {{$t('inspection.recommendation_kind')}}
          </div>
        <div class="col s6">
        <select v-model="recommendation.kind">
          <option value="correction"> {{$t('recommendations.correction')}}</option>
          <option value="fixing"> {{$t('recommendations.repairs')}}</option>
          <option value="prevention"> {{$t('recommendations.prevention')}}</option>
          <option value="emergency"> {{$t('recommendations.emergency')}}</option>
        </select>
      </div>
        </div>
        <textarea v-model="recommendation.solution" :placeholder="$t('inspection.solution_placeholder')" />
      </div>
      <div class="modal-footer">
        <button class="btn-small solidgreen" v-on:click="save()">{{$t('menu.buttons.save')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      uid: _.uniqueId("recommendation")
    }
  },
  props: {recommendation: Object},
  mounted() {
    var elemss = this.$el.querySelectorAll('.modal');
    this.instances = M.Modal.init(elemss, {});
  },
  methods: {
    save(){
      this.$emit('saved', this.recommendation);
      this.instances[0].close();
    },
    removeRecommendation(reco){
      this.$emit('removed', reco);
    }
  }
}
</script>
<style scoped>
  select {
    display: block;
  }
  .modal{
    border: 5px solid #00CC66;
    border-radius: 15px;
  }
  h5{
    font-size: 15px;
    text-transform: uppercase;
  }
</style>